import axios from 'axios'
import { baseUrl, deviceUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 查询实时视频websocket通讯地址
 * @param {*} userId 用户id
 * @param {*} logId  记录id
 */
export function getRealVideoUrl() {
  const url = baseUrl + `/config/APP_MVCP_URL`

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.data == null || res.data.data == null) {
      console.error('未获取到实时视频websocket通讯地址')
    }
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '获取到实时视频websocket通讯地址', res)
    }
    return Promise.resolve(res.data.data)
  })
}
/**
 * 查询rtmp地址
 */
 export function getRtmpUrl() {
  const url = baseUrl + '/config/APP_MVCP_RTMP'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.data == null || res.data.data == null) {
      console.error('未获取到rtmp地址')
    }
    return Promise.resolve(res.data.data)
  })
}

/**
 * 查询所有设备的状态信息
 */
 export function getSelectStatus() {
  const url = deviceUrl + '/device/select/status'

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询所有设备的状态信息', res)
    }
    return Promise.resolve(res.data.data)
  })
}
